import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export const initSlopesBlock = () => {
    Array.from(document.querySelectorAll('.slopes .swiper')).forEach(b => {
        if (b.inited) {
            return;
        }
        b.inited = true;

        const swiper = new Swiper(b, {
            modules: [Pagination, Navigation],
            loop: false,
            spaceBetween: 32,
            slidesPerView: 'auto',
            pagination: {
                el: b.querySelector('.swiper-pagination'),
                clickable: true,
            },
            navigation: {
                nextEl: b.closest('.slopes').querySelector('.swiper-arrow--next'),
                prevEl: b.closest('.slopes').querySelector('.swiper-arrow--prev'),
            }
        });
    }); 
};

(() => {
    initSlopesBlock();
})();
